import {
  SET_REPORT_DRAFT_UPDATED,
  SET_REPORT_LOCK_ACQUIRED,
  SET_REPORT_LOCK_RELEASED,
  SET_CASE_ASSIGNMENT_CHANGED,
  CLEAR_CASE_ASSIGNMENT_CHANGED,
} from "../definitions/reportLockConstants";

export interface ReportLockUser {
  id: number;
  type: string;
  name: string;
  display_name: string;
  admin?: { id: number; name: string };
}

export interface DraftUpdatePayload {
  reportId: number;
  content: string;
  savedBy: ReportLockUser;
  savedAt: string;
}

export interface SetReportLockAcquiredAction {
  type: typeof SET_REPORT_LOCK_ACQUIRED;
  payload: {
    eventId: number;
    reportId: number;
    lockedBy: ReportLockUser;
  };
}

export interface SetReportLockReleasedAction {
  type: typeof SET_REPORT_LOCK_RELEASED;
  payload: {
    eventId: number;
    reportId: number;
    forceReleased: boolean;
  };
}

export interface SetReportDraftUpdatedAction {
  type: typeof SET_REPORT_DRAFT_UPDATED;
  payload: {
    eventId: number;
    draftUpdate: DraftUpdatePayload;
  };
}

export interface SetCaseAssignmentChangedAction {
  type: typeof SET_CASE_ASSIGNMENT_CHANGED;
  payload: { eventId: number; caseId: number | null; isRemoved: boolean };
}

export interface ClearCaseAssignmentChangedAction {
  type: typeof CLEAR_CASE_ASSIGNMENT_CHANGED;
}

let _eventCounter = 0;

export const setReportLockAcquired = (
  reportId: number,
  lockedBy: ReportLockUser
): SetReportLockAcquiredAction => ({
  type: SET_REPORT_LOCK_ACQUIRED,
  payload: { eventId: ++_eventCounter, reportId, lockedBy },
});

export const setReportLockReleased = (
  reportId: number,
  forceReleased: boolean
): SetReportLockReleasedAction => ({
  type: SET_REPORT_LOCK_RELEASED,
  payload: { eventId: ++_eventCounter, reportId, forceReleased },
});

export const setReportDraftUpdated = (
  draftUpdate: DraftUpdatePayload
): SetReportDraftUpdatedAction => ({
  type: SET_REPORT_DRAFT_UPDATED,
  payload: { eventId: ++_eventCounter, draftUpdate },
});

export const setCaseAssignmentChanged = (
  caseId: number | null,
  isRemoved: boolean = false
): SetCaseAssignmentChangedAction => ({
  type: SET_CASE_ASSIGNMENT_CHANGED,
  payload: { eventId: ++_eventCounter, caseId, isRemoved },
});

export const clearCaseAssignmentChanged = (): ClearCaseAssignmentChangedAction => ({
  type: CLEAR_CASE_ASSIGNMENT_CHANGED,
});
